// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__3R8FC","clinicsSelect":"TableHeading_clinicsSelect__XeKtB"};